import { useEffect, useState } from "react";

import { useTheme } from "@/components/admin/use-theme";

/**
 * The app's ThemeProvider stores "light" | "dark" | "system"; the Google Map
 * needs a concrete scheme. Resolve "system" via matchMedia and track OS
 * changes live.
 */
export const useResolvedTheme = (): "light" | "dark" => {
  const { theme } = useTheme();
  const [system, setSystem] = useState<"light" | "dark">(() =>
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light",
  );

  useEffect(() => {
    if (theme !== "system") return;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = (e: MediaQueryListEvent) =>
      setSystem(e.matches ? "dark" : "light");
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [theme]);

  return theme === "system" ? system : theme;
};
